import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../features/filters/filterSlice";

const Pagination = () => {
	const dispatch = useDispatch();
	const { pages } = useSelector((state) => state.transaction);
	const { currentPage } = useSelector((state) => state.filters);

	const handlePageChange = (page) => {
		dispatch(setCurrentPage(page));
	};

	let content = null;
	if (pages > 0) {
		content = [...Array(pages)].map((value, index) => (
			<p
				key={index}
				className={`rounded-full px-2 md:py-1 py-0.5 text-sm md:text-base font-medium md:px-3 border border-green-300 w-fit cursor-pointer ${
					currentPage === index + 1 ? "bg-green-700 text-white" : "bg-green-200"
				}`}
				onClick={() => handlePageChange(index + 1)}
			>
				{index + 1}
			</p>
		));
	}

	return (
		<div className="flex gap-2 pt-4 justify-end">
			{content}
		</div>
	);
};

export default Pagination;
